import { gsap } from "../global/gsap";

const initShortCourseHover = (shortCourseHover) => {
    const items = shortCourseHover.querySelectorAll('.js-hover');

    if (window.matchMedia('(pointer: fine)').matches) {
        items.forEach((item) => {
            item.addEventListener("mouseenter", () => {
                item.classList.toggle('is-active');
            });
        });
    } else {
        // Mobile - randomly toggle items at 500ms interval
        setInterval(() => {
            const item = items[Math.floor(Math.random() * items.length)];
            item.classList.toggle('is-active');
        }, 500);
    }
};

export { initShortCourseHover as default };
